import { AuthProvider } from '@/contexts/auth';
import { AuthGate } from '@/components/AuthGate';

function App() {
  return (
    <div className="min-h-screen bg-background">
      <AuthProvider>
        <AuthGate />
      </AuthProvider>
    </div>
  );
}

export default App;
